export enum Funcionalidade {
    DASHBOARD = <any> "Dashboard",
    EXPORTACAO_DE_DADOS = <any> "Exportação de dados",
    CADASTRO_DE_USUARIOS = <any> "Cadastro de usuários",
    CADASTRO_DE_EMPRESAS = <any> "Cadastro de empresas",
    CONFIGURACAO = <any> "Configuração",
    CONSULTA_DE_LOG = <any> "Consulta de Log",
    CADASTRO_DE_PLANOS = <any> "Consulta de planos",
    CADASTRO_DE_BACKUPS = <any> "Consulta de backups",
    CONSULTA_DE_RESTORES = <any> "Consulta de restaurações"
  }



// WEBPACK FOOTER //
// ./src/app/util/enum/funcionalidade.enum.ts